import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withRouter } from "react-router-dom";
import { addZone, renameZone, renameDashboardApi } from "../api";
import { setNewDashboardZone, updateZone, renameDashboard } from "../redux";
import { Alert } from "../shared";
import { useTranslation } from "react-i18next";
import { FiHome, FiPlus, FiTrash2, FiEdit2, FiSave, FiCheck } from "react-icons/fi";

const AddDetailsComp = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardDetails = useSelector((state) => state.dashboardDetails);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const zoneWidget = useSelector((state) => state.zoneWidgets.zoneWidgets);
  
  const [zoneIndex, setZoneIndex] = useState(null);
  const [showAddZone, setShowAddZone] = useState(false);
  const form = useRef(null);
  const formEdit = useRef(null);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  const initialValues = {
    zone_caption: "",
  };

  const submitForm = () => {
    const formData = new FormData(form.current);
    formData.append("dashboard", dashboardDetails.id);
    addZone(formData, token)
      .then((res) => {
        setShowAddZone(false);
        dispatch(
          setNewDashboardZone({
            id: res.data.data,
            zone_caption: formData.get("zone_caption"),
          })
        );
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchema = Yup.object({
    zone_caption: Yup.string().required(t("نام اتاق را وارد کنید.")),
  });

  const initialRenameValues = {
    dashboard_caption: dashboardDetails.dashboard_caption || "",
  };

  const submitRenameForm = () => {
    const formData = new FormData(formEdit.current);
    formData.append("dashboard", dashboardDetails.id);
    renameDashboardApi(formData, token)
      .then((res) => {
        formEdit.current.reset();
        dispatch(
          renameDashboard({
            id: res.data.data,
            dashboard_caption: formData.get("dashboard_caption"),
          })
        );
        setShowAlert({
          show: true,
          message: t("خانه با موفقیت ویرایش شد."),
          type: "Success",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 5000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchemaRename = Yup.object({
    dashboard_caption: Yup.string().required(t("نام ساختمان را وارد کنید.")),
  });

  const [zone, setZone] = useState({
    zones: [],
    id: null,
    index: null,
  });

  const onChangeRenameZone = (id, index, event) => {
    var zones = zone.zones.slice();
    zones[index] = event.target.value;
    setZone({ zones: zones, id: id, index: index });
  };

  const submitRenameZone = () => {
    const formData = new FormData();
    formData.append("zone", zone.id);
    formData.append("zone_caption", zone.zones[zone.index]);
    renameZone(formData, token)
      .then(() => {
        dispatch(
          updateZone({ id: zone.id, zone_caption: zone.zones[zone.index] })
        );
        setZoneIndex(null);
        setShowAlert({
          show: true,
          message: t("اتاق با موفقیت ویرایش شد."),
          type: "Success",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 3000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const deleteZone = (id) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var formdata = new FormData();
    formdata.append("zone", id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://assessn.mmaviot.com/api/zone_widgets", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        result.data.length
          ? setShowAlert({
              show: true,
              message: t(
                "این ناحیه حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد."
              ),
              type: "Warning",
              question: false,
            })
          : setShowAlert({
  show: true,
  message: t("آیا از حذف این اتاق اطمینان دارید؟"),
  type: "Warning",
  question: true,  
  id: id,
  request: "zone",
});
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
        }, 10000);
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <div className="add-details-container">
      {/* Rename Building Section */}
      <div className="add-details-section">
        <h3 className="add-details-title">{t("ویرایش نام ساختمان")}</h3>
        <Formik
          initialValues={initialRenameValues}
          onSubmit={submitRenameForm}
          validationSchema={validationSchemaRename}
        >
          {(formProps) => (
            <Form ref={formEdit}>
              <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
                <div className="setting-item-label">
                  <FiHome size={16} />
                  <span>{t("نام ساختمان")}</span>
                </div>
                <input
                  type="text"
                  defaultValue={dashboardDetails.dashboard_caption}
                  className="setting-input"
                  name="dashboard_caption"
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                />
                <ErrorMessage name="dashboard_caption">
                  {(errMsg) => <div className="setting-error">{errMsg}</div>}
                </ErrorMessage>
                <div className="setting-buttons" style={{ marginTop: "8px" }}>
                  <button type="submit" className="setting-back-btn" style={{ padding: "10px" }}>
                    <FiSave size={16} />
                    <span>{t("ذخیره")}</span>
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Zones Section */}
      <div className="add-details-section">
        <div className="zones-header">
          <h3 className="add-details-title">{t("اتاق‌ها")}</h3>
          <button
            className="add-zone-btn"
            onClick={() => setShowAddZone(true)}
          >
            <FiPlus size={16} />
            <span>{t("اتاق جدید")}</span>
          </button>
        </div>

        {/* Add New Zone Form */}
        {showAddZone && (
          <div className="add-zone-form">
            <Formik
              initialValues={initialValues}
              onSubmit={submitForm}
              validationSchema={validationSchema}
            >
              {(formProps) => (
                <Form ref={form}>
                  <div className="add-zone-input-wrapper">
                    <input
                      type="text"
                      placeholder={t("نام اتاق")}
                      name="zone_caption"
                      className="setting-input"
                      onChange={formProps.handleChange}
                      onBlur={formProps.handleBlur}
                    />
                    <button type="submit" className="add-zone-submit">
                      <FiCheck size={18} />
                    </button>
                  </div>
                  <ErrorMessage name="zone_caption">
                    {(errMsg) => <div className="setting-error">{errMsg}</div>}
                  </ErrorMessage>
                </Form>
              )}
            </Formik>
          </div>
        )}

        {/* Zones List */}
        <div className="zones-list">
          {dashboardZones?.map((zoneItem, index) => {
            const isEditing = zoneIndex === index;
            return (
              <div key={index} className="zone-item-card">
                {!isEditing ? (
                  <div className="zone-item-content">
                    <div className="zone-item-icon">
                      <FiHome size={16} />
                    </div>
                    <span className="zone-item-name">{zoneItem.zone_caption}</span>
                  </div>
                ) : (
                  <input
                    type="text"
                    defaultValue={zoneItem.zone_caption}
                    className="zone-edit-input"
                    onChange={(event) =>
                      onChangeRenameZone(zoneItem.id, index, event)
                    }
                  />
                )}
                <div className="zone-item-actions">
                  {!isEditing ? (
                    <>
                      <button
                        className="zone-edit-btn"
                        onClick={() => setZoneIndex(index)}
                        title={t("ویرایش")}
                      >
                        <FiEdit2 size={14} />
                      </button>
                      <button
                        className="zone-delete-btn"
                        onClick={() => deleteZone(zoneItem.id)}
                        title={t("حذف")}
                      >
                        <FiTrash2 size={14} />
                      </button>
                    </>
                  ) : (
                    <button
                      className="zone-save-btn"
                      onClick={submitRenameZone}
                      title={t("ذخیره")}
                    >
                      <FiSave size={14} />
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          id={showAlert.id}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
    </div>
  );
};

const AddDetails = withRouter(AddDetailsComp);

export { AddDetails };